import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { PermissionService } from '../core/services/user/permission.service';

@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanActivate {
    constructor(private permissionService: PermissionService, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const expectedPermissions = route.data['permissions'] as string[];

        if (!expectedPermissions || expectedPermissions.length === 0) {
            return true;
        }

        const hasAccess = this.permissionService.hasAnyPermission(expectedPermissions);

        if (!hasAccess) {
            this.router.navigate(['/dashboard/main']);
            return false;
        }

        return true;
    }
}